import { memo, type ReactNode } from 'react'

import { Table } from '@/components/ui/table'

import type { DataTableAction, DataTableColumn, SortOrder } from './data-table.interface'
import { DataTableBody } from './data-table-body.molecule'
import { DataTableHeader } from './data-table-header.molecule'

export interface DataTableContentComponentProps<TData> {
  data: TData[]
  columnList: DataTableColumn<TData>[]
  getRowId: (row: TData) => string
  isSelectable: boolean
  isAllSelected: boolean
  isIndeterminate: boolean
  onSelectAll: (isChecked: boolean) => void
  isRowSelected: (rowId: string) => boolean
  onSelectRow: (rowId: string, isChecked: boolean) => void
  actionList: DataTableAction<TData>[]
  hasActions: boolean
  totalColSpan: number
  emptyMessage: string
  onSortChange?: (sortBy: string, sortOrder: SortOrder) => void
  getColumnSortOrder: (columnId: string) => SortOrder | null
  onSort: (columnId: string) => void
}

const DataTableContentInner = <TData,>({
  data,
  columnList,
  getRowId,
  isSelectable,
  isAllSelected,
  isIndeterminate,
  onSelectAll,
  isRowSelected,
  onSelectRow,
  actionList,
  hasActions,
  totalColSpan,
  emptyMessage,
  onSortChange,
  getColumnSortOrder,
  onSort,
}: DataTableContentComponentProps<TData>): ReactNode => (
  <div className="data-table rounded-md border">
    <Table>
      <DataTableHeader
        columnList={columnList}
        isSelectable={isSelectable}
        isAllSelected={isAllSelected}
        isIndeterminate={isIndeterminate}
        onSelectAll={onSelectAll}
        hasActions={hasActions}
        onSortChange={onSortChange}
        getColumnSortOrder={getColumnSortOrder}
        onSort={onSort}
      />
      <DataTableBody
        data={data}
        columnList={columnList}
        getRowId={getRowId}
        isSelectable={isSelectable}
        isRowSelected={isRowSelected}
        onSelectRow={onSelectRow}
        actionList={actionList}
        hasActions={hasActions}
        totalColSpan={totalColSpan}
        emptyMessage={emptyMessage}
      />
    </Table>
  </div>
)

export const DataTableContent = memo(DataTableContentInner) as typeof DataTableContentInner
